import { useFacetData } from '~/context/common/FacetDataContext';
import ColorSwatches from './ColorSwatches';
import FilterDrawer from '../FilterDrawer';

type OwnProps = {
  facetKey: 'interiorColors' | 'colors';
};

export default function ColorFacet({ facetKey }: OwnProps) {
  const facetData = useFacetData();

  return (
    <FilterDrawer
      testId={`facet-colors-${facetKey}`}
      facetContent={facetData[facetKey]?.buckets ?? []}
      facetName={facetKey === 'colors' ? 'Exterior Color' : 'Interior Color'}
    >
      <ColorSwatches filterKey={facetKey} />
    </FilterDrawer>
  );
}
